import { IPractice } from '@principle-theorem/principle-core/interfaces';
import { DocumentReference, Region } from '@principle-theorem/shared';
import { first } from 'lodash';
import { getBirthdayCampaignTemplate } from './birthday-campaign-template';
import { getBlankCampaignTemplate } from './blank-campaign-template';
import { getColdContactReactivationCampaignTemplate } from './cold-contact-reactivation-campaign-template';
import { getHealthFundExpiringCalendarYearCampaignTemplate } from './health-fund-expiring-calendar-year-campaign-template';
import { getHealthFundExpiringFinancialYearCampaignTemplate } from './health-fund-expiring-financial-year-campaign-template';
import { IMarketingCampaignTemplate } from './marketing-campaign-template';
import { getOnceOffEmailCampaignTemplate } from './once-off-email-campaign-template';
import { getOnceOffSmsCampaignTemplate } from './once-off-sms-campaign-template';
import { getReactivationHealthFundPatientsCampaignTemplate } from './reactivation-health-fund-campaign-template';
import { getReactivationNonHealthFundPatientsCampaignTemplate } from './reactivation-non-health-fund-campaign-template';
import { getReactivationPatientsCampaignTemplate } from './reactivation-nz-campaign-template';
import { getRecallCampaignTemplate } from './recall-campaign-template';

export function getMarketingCampaignTemplates(
  practiceRef: DocumentReference<IPractice>,
  region: Region
): IMarketingCampaignTemplate[] {
  const templates: IMarketingCampaignTemplate[] = [
    getBlankCampaignTemplate(practiceRef),
    getBirthdayCampaignTemplate(practiceRef),
    getRecallCampaignTemplate(practiceRef),
    getColdContactReactivationCampaignTemplate(practiceRef),
    getHealthFundExpiringCalendarYearCampaignTemplate(practiceRef),
    getHealthFundExpiringFinancialYearCampaignTemplate(practiceRef),
    getReactivationPatientsCampaignTemplate(practiceRef),
    getReactivationHealthFundPatientsCampaignTemplate(practiceRef),
    getReactivationNonHealthFundPatientsCampaignTemplate(practiceRef),
    getOnceOffEmailCampaignTemplate(practiceRef),
    getOnceOffSmsCampaignTemplate(practiceRef),
  ];

  return templates.filter((template) => template.regions.includes(region));
}

export function getDefaultMarketingCampaignTemplate(
  practiceRef: DocumentReference<IPractice>,
  region: Region
): IMarketingCampaignTemplate {
  const templates = getMarketingCampaignTemplates(practiceRef, region);
  const defaultTemplate = first(templates);
  if (!defaultTemplate) {
    throw new Error('No marketing campaign templates available');
  }
  return defaultTemplate;
}
